var _circle, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#183883"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 15.5,
    width: 7,
    height: 7,
    rx: 1.5,
    stroke: "#183883"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 27.5,
    width: 7,
    height: 7,
    rx: 1.5,
    stroke: "#183883"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 15.5,
    width: 7,
    height: 7,
    rx: 1.5,
    stroke: "#183883"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 27.5,
    width: 7,
    height: 7,
    rx: 1.5,
    stroke: "#183883"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllOffers);
export default __webpack_public_path__ + "static/media/AllOffers.6ffd88eab399c6ffe8d4508d0dc0da41.svg";
export { ForwardRef as ReactComponent };